
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.66 7a2.625 2.625 0 10.001-5.25 2.625 2.625 0 000 5.25zm1.838.656h-.342a3.574 3.574 0 01-2.99 0h-.343a2.757 2.757 0 00-2.756 2.756v.854c0 .543.441.984.985.984h7.218c.544 0 .985-.44.985-.984v-.854a2.757 2.757 0 00-2.757-2.756z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.99 3.669a.674.674 0 00-.673.673v.906H1.42a.674.674 0 100 1.348h.898v.89a.674.674 0 101.347 0v-.89h.898a.674.674 0 000-1.348h-.898v-.906a.674.674 0 00-.673-.673z","fill":"#282E3E"}})])
          )
        }
      }
    